import { isEmpty, isObject, isArray, includes, omit } from "lodash";
import qs from "qs";

//详情态下需要设置disabled禁用态的组件
const COMPONENT_DISABLED_IN_DETAIL_LIST = [
  "AddressMacao",
  "AddressSelect",
  "CascadeDate",
  "CascadeMultiSelect",
  "CascadeSelect",
  "Date",
  "FloatNumber",
  "FormatInput",
  "Input",
  "MultiLevelAddressSelect",
  "MultiSelect",
  "Number",
  "PreSuffixInput",
  "RegionSelect",
  "SearchInput",
  "Select",
  "SymbolInput",
  "Textarea",
  "Captcha",
];

export const recursionFindElement = (target, dataSource = []) => {
  if (!isArray(dataSource)) {
    return;
  }

  return dataSource.find((item) => {
    const inArray = isObject(target)
      ? item.value === target.value
      : item.value === target;

    if (inArray) {
      return item;
    }

    return recursionFindElement(target, item.children);
  });
};

export const isValueInOptions = (value, options = [], componentName) => {
  if (isEmpty(value)) {
    return true;
  }

  if (Array.isArray(value)) {
    const isExistArr = [];
    // 如果是多选组件，因为值与值之间无层级联系，
    // 可以理解为 value.forEach(item => isExistArr.push(!!recursionFindElement(item)))
    // 其余组件因为值与值之间有层级联系，需要用每一级的children去做
    if (["CascadeMultiSelect", "MultiSelect"].includes(componentName)) {
      value.forEach((target) => {
        if (isEmpty(options)) {
          isExistArr.push(false);
        }

        const item = recursionFindElement(target, options);
        isExistArr.push(!!item);
      });
    } else {
      value.reduce((opts, val) => {
        if (isEmpty(opts)) {
          isExistArr.push(false);
          return [];
        }

        const item = opts.find((it) =>
          isObject(val) ? it.value === val.value : it.value === val
        );
        isExistArr.push(!!item);
        return item ? item.children || opts : [];
      }, options);
    }

    return isExistArr.every((item) => item === true);
  }
  return options.some((item) =>
    isObject(value) ? item.value === value.value : item.value === value
  );
};

export function uuid(len = 8) {
  const chars =
    "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz".split("");
  const result = [];
  const radix = chars.length;
  let i;
  // Compact form
  for (i = 0; i < len; i++) {
    // eslint-disable-next-line no-bitwise
    result[i] = chars[0 | (Math.random() * radix)];
  }
  return result.join("");
}

export const getParams = () => {
  return qs.parse(location.href.toString().split("?")[1]);
};

export const IsJsonString = (str) => {
  try {
    JSON.parse(str);
  } catch (e) {
    return false;
  }
  return true;
};

/**
 * 创建自定义事件
 * @param {*} eventName
 * @returns
 */
export function createNewEvent(eventName) {
  let event;
  if (typeof Event === "function") {
    event = new Event(eventName);
  } else {
    event = document.createEvent("Event");
    event.initEvent(eventName, true, true);
  }

  return event;
}

//判断组件是在详情态下需要disabled
export const isComponentDisabledInDetail = (componentName) => {
  return includes(COMPONENT_DISABLED_IN_DETAIL_LIST, componentName);
};
